module.exports = __webpack_public_path__ + "img/l.c5e15ff7.png";